/*eslint-disable */
const $ = window.jQuery = require('jquery');

import axios from 'axios';
import moment from 'moment';
import root from '@/_helpers/roots';

let modelFiltersApiUrl = root.sharedModulsApiUrl.link;

export default {
  name: 'shared-models-list',
  components: {
  },
  props: [],
  data () {
    return {
      sharedAlgoList:null,
      sharedAlgoListResults:[],
      algoListForClassification:[
        'Logistic Regression',
        'Decision Tree Classifier',
        'Random Forest Classifier',
        'Gradient Boosting Classifier',
        'Support Vector Classifier',
        'Gaussian Naive Bias',
        'K-Neighbors Classifier'
      ],
      algoListForRegression:[
        'Linear Regression',
        'Decision Tree Regressor',
        'Random Forest Regressor',
        'Gradient Boosting Regressor',
        'Support Vector Regressor',
        'K-Neighbors Regressor'
      ],
      is_type:'',
      is_algorithm:'',
      is_disease:'',
      is_year:'',
      is_month:'',
      is_month_name:'',
      diseaseListResults:[],
      userLoading:false,
      isSelectedAlgoData:[],
      filterEnabledState:false
    }
  },
  computed: {
  },
  mounted () {
    this.getSharedModelsListFunc();
    this.$store.dispatch('getDiseaseListForAiDashFun').then((res) => {
      this.diseaseListResults = res.data.data.results
    })
  },
  methods: {
    clearFiltersMethod(){
      this.filterEnabledState = false
      this.is_type = '' 
      this.is_algorithm = ''
      this.is_disease = ''
      this.is_year = ''
      this.is_month_name = ''
      this.is_month = ''
      this.userLoading = true
      this.$store.dispatch('getSharedModelsForAiDashFun').then((res) => {
        this.sharedAlgoList = res.data.data
        this.sharedAlgoListResults = this.sharedAlgoList.results 
        this.userLoading = false
      }).catch((err) => {
        this.userLoading = false
      })
    },
    filterByIsTypeMethod(val){
      this.filterEnabledState = true
      this.is_type = val
      this.userLoading = true
      if(val == 'classification'){
        this.isSelectedAlgoData = this.algoListForClassification
      }else{
        this.isSelectedAlgoData = this.algoListForRegression
      }
      axios.get(modelFiltersApiUrl + '?is_year=' + this.is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.sharedAlgoList = response.data.data
        this.sharedAlgoListResults = this.sharedAlgoList.results
        this.userLoading = false
      })
    },
    filterByIsAlgoMethod(val){
      this.filterEnabledState = true
      this.is_algorithm = val
      this.userLoading = true
      axios.get(modelFiltersApiUrl + '?is_year=' + this.is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.sharedAlgoList = response.data.data
        this.sharedAlgoListResults = this.sharedAlgoList.results
        this.userLoading = false
      })
    },
    filterByIsDiseaseMethod(val){
      this.filterEnabledState = true
      this.is_disease = val
      this.userLoading = true
      axios.get(modelFiltersApiUrl + '?is_year=' + this.is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.sharedAlgoList = response.data.data
        this.sharedAlgoListResults = this.sharedAlgoList.results
        this.userLoading = false
      })
    },
    filterByIsYearMethod(val){
      this.filterEnabledState = true
      this.is_year = val
      this.userLoading = true
      axios.get(modelFiltersApiUrl + '?is_year=' + this.is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.sharedAlgoList = response.data.data
        this.sharedAlgoListResults = this.sharedAlgoList.results
        this.userLoading = false
      })
    },
    filterByIsMonthMethod(name, val){
      this.filterEnabledState = true
      this.is_month_name = name
      this.is_month = val
      this.userLoading = true
      const is_year = this.is_year || moment(new Date()).format('YYYY')
      axios.get(modelFiltersApiUrl + '?is_year=' + is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.sharedAlgoList = response.data.data
        this.sharedAlgoListResults = this.sharedAlgoList.results
        this.userLoading = false
      })
    },
    getSharedModelsListFunc() {
      this.$store.dispatch('getSharedModelsForAiDashFun').then((res) => {
        this.sharedAlgoList = res.data.data
        this.sharedAlgoListResults = this.sharedAlgoList.results 
      })
    },
  },
  watch:{
  }
}